import React from 'react'
import {CartesianGrid, ComposedChart, Line, Tooltip, XAxis} from 'recharts'
import {Rental} from '../../../common/types/rental'
import {CustomCartesianGridTooltip} from './CustomCartesianGridTooltip'
import {getPercentageLabelList} from './getPercentageLabelList'
import {generateRentalFailuresTimeOfDayData} from './utils/generateRentalFailuresTimeOfDayData'

interface Props {
  rentals: Rental[]
}

export const RentalFailuresTimeOfDay: React.FC<Props> = ({rentals}) => {
  const data = generateRentalFailuresTimeOfDayData(rentals)

  return (
    <ComposedChart
      width={1000}
      height={400}
      data={data}
      margin={{
        top: 20,
        right: 20,
        bottom: 20,
        left: 20,
      }}
    >
      <CartesianGrid stroke="#f5f5f5" />
      <XAxis dataKey="label" />
      <Tooltip content={<CustomCartesianGridTooltip showCount={true} />} />
      <Line type="monotone" dataKey="percentage" stroke="#B40A7A" strokeWidth={2} name="Alla misslyckade hyror">
        {getPercentageLabelList()}
      </Line>
    </ComposedChart>
  )
}
